import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import DstButton from "../../../../components/DstButton/DstButton";
import infoRow from "../../../../components/InfoRow/InfoRow";
import { PermissionComponent } from "../../../../services/PermissionGuard";
import { formatDateHumanly } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { ModuleGeneralInformationProps } from "./ModuleGeneralInformation.d";
import UpdateModal from "./modal/UpdateModal";

const ModuleGeneralInformation = ({ moduleData, language, onDelete, onEditSave }: ModuleGeneralInformationProps) => {
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <div className="col-lg">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3 className="mb-0 m-bold">{translate(language, "PAGES.MODULE.GENERAL_INFO.SECTION_TITLE")}</h3>
              <div className="d-flex">
                <PermissionComponent neededPermission={[{ methods: ["DELETE"], route: "/modules/*" }]}>
                  <DstButton
                    btnClass="ms-2"
                    variant="danger"
                    btnImageBefore={<span className="dst-icon-trash-01 me-2" />}
                    value={translate(language, "PAGES.MODULE.GENERAL_INFO.DELETE")}
                    clickFunction={onDelete}
                  />
                </PermissionComponent>
                <PermissionComponent neededPermission={[{ methods: ["PATCH"], route: "/modules/*" }]}>
                  <DstButton
                    btnClass="ms-2"
                    variant="secondary"
                    btnImageBefore={<span className="dst-icon-edit-02 me-2" />}
                    value={translate(language, "PAGES.MODULE.GENERAL_INFO.EDIT")}
                    clickFunction={() => setShowEditModal(true)}
                  />
                </PermissionComponent>
              </div>
            </div>
            {infoRow("dst-icon-hash-01", translate(language, "PAGES.MODULE.GENERAL_INFO.ID"), moduleData.id)}
            {infoRow("dst-icon-tag-01", translate(language, "PAGES.MODULE.GENERAL_INFO.NAME"), moduleData.name)}
            {infoRow(
              "dst-icon-align-left",
              translate(language, "PAGES.MODULE.GENERAL_INFO.DESCRIPTION"),
              moduleData.description
            )}
            {infoRow(
              "dst-icon-translate-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.LANGUAGE"),
              moduleData.language
            )}
            {infoRow(
              "dst-icon-code-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.PROGRAMMING_LANGUAGE"),
              moduleData.programming_language
            )}
            {infoRow(
              "dst-icon-target-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.PURPOSE"),
              moduleData.purpose
            )}
            {infoRow(
              "dst-icon-power-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.STATUS"),
              moduleData?.is_deprecated
                ? translate(language, "PAGES.MODULE.COMMON.DEPRECATED")
                : translate(language, "PAGES.MODULE.COMMON.ACTIVE")
            )}
            {infoRow(
              "dst-icon-calendar-plus-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.CREATED_DATE"),
              formatDateHumanly(language, moduleData.dt_created)
            )}
            {infoRow(
              "dst-icon-clock-refresh",
              translate(language, "PAGES.MODULE.GENERAL_INFO.UPDATED_DATE"),
              moduleData?.dt_updated ? formatDateHumanly(language, moduleData.dt_updated) : <span>-</span>
            )}
          </div>
        </Col>
        <Col md={6}>
          <div className="col-lg">
            <div className="d-flex align-items-center justify-content-between my-3">
              <h3 className="mb-0 m-bold">{translate(language, "PAGES.MODULE.GENERAL_INFO.OWNER")}</h3>
            </div>
            {infoRow(
              "dst-icon-user-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.OWNER_NAME"),
              <Link to={`/user/${moduleData.owner.id}`}>
                {moduleData.owner.first_name} {moduleData.owner.last_name}
              </Link>
            )}
            {infoRow(
              "dst-icon-mail-01",
              translate(language, "PAGES.MODULE.GENERAL_INFO.OWNER_EMAIL"),
              moduleData?.owner?.email
            )}
            {moduleData?.origin_program && (
              <React.Fragment>
                <div className="d-flex align-items-center justify-content-between my-3">
                  <h3 className="mb-0 m-bold">
                    {translate(language, "PAGES.MODULE.GENERAL_INFO.ORIGIN_PROGRAM.TITLE")}
                  </h3>
                </div>
                {infoRow(
                  "dst-icon-folder-closed",
                  translate(language, "PAGES.MODULE.GENERAL_INFO.ORIGIN_PROGRAM.NAME"),
                  moduleData.origin_program.name
                )}
                {infoRow(
                  "dst-icon-align-left",
                  translate(language, "PAGES.MODULE.GENERAL_INFO.ORIGIN_PROGRAM.DESCRIPTION"),
                  moduleData.origin_program.description
                )}
                {infoRow(
                  "dst-icon-link-external-01",
                  translate(language, "PAGES.MODULE.GENERAL_INFO.ORIGIN_PROGRAM.EXTERNAL"),
                  moduleData.origin_program.is_external
                    ? translate(language, "PAGES.MODULE.COMMON.YES")
                    : translate(language, "PAGES.MODULE.COMMON.NO")
                )}
                {infoRow(
                  "dst-icon-translate-01",
                  translate(language, "PAGES.MODULE.GENERAL_INFO.ORIGIN_PROGRAM.LANGUAGE"),
                  moduleData.origin_program.language
                )}
              </React.Fragment>
            )}
          </div>
        </Col>
      </Row>

      <UpdateModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        moduleData={moduleData}
        language={language}
        onEditSave={onEditSave}
      />
    </React.Fragment>
  );
};

export default ModuleGeneralInformation;
